import { useMutation } from '@redwoodjs/web'

import { LOCAL_STORAGE_VIEW_KEY } from 'src/lib/constants'

import { getLocalViews, resetLocalViews } from './localViews'
import { resetLocalViewsUnlock } from './localViewUnlock'

const MUTATION_IMPORT = gql`
  mutation MUTATION_IMPORT($input: ImportViewsInput!) {
    importViews(input: $input)
  }
`

function clearLocalViews() {
  localStorage.removeItem(LOCAL_STORAGE_VIEW_KEY)
}

export function useImportViews() {
  const [importViews] = useMutation(MUTATION_IMPORT, {
    onCompleted: () => {
      clearLocalViews()
    },
  })

  return async () => {
    const localViews = getLocalViews().views
    resetLocalViews()
    resetLocalViewsUnlock()
    if (localViews.length) {
      importViews({
        variables: {
          input: { views: localViews.map((view) => view.itListId) },
        },
      })
    }
  }
}
